module.exports = __webpack_public_path__ + "static/img/error.ca2dbbf5.png";